module.exports = __webpack_public_path__ + "img/用电服务平台单位概况.34c87f25.png";